var amt_admin = require('amt_admin').default;
var app = require("angular").module("ww2_analytics.single_arena", [amt_admin]);

var activity_tpl = require('./activity.html');
var battles_tpl = require('./battles.html');
var tickets_income_tpl = require('./tickets_income.html');


app.config([
  "$stateProvider",
  function($stateProvider) {
    $stateProvider.state("amt.ww2.single_arena", {
      url: "/single_arena",
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: "Single Arena",
        role: "single_arena"
      },
      menu: {
        glyphicon: 'text-background',
        childs: [
            {
              state: "amt.ww2.single_arena.activity",
              glyphicon: "flash"
            },
            {
              state: "amt.ww2.single_arena.battles",
              glyphicon: "cutlery"
            },
            {
              state: "amt.ww2.single_arena.tickets_income",
              glyphicon: "shopping-cart"
            },
        ]
    }
    })
    .state('amt.ww2.single_arena.activity', {
        url: '/activity',
        template: activity_tpl,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Activity',
            role: 'single_arena'
        }
    })
    .state('amt.ww2.single_arena.battles', {
        url: '/battles',
        template: battles_tpl,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Battles',
            role: 'single_arena'
        }
    })
    .state('amt.ww2.single_arena.tickets_income', {
        url: '/tickets_income',
        template: tickets_income_tpl,
        reloadOnSearch: false,
        data: {
            priority: 801,
            title: 'Tickets Income',
            role: 'single_arena'
        }
    })
  }
]);

export default app.name;
